export default __webpack_public_path__ + "static/media/vip-contact-icon.c43bc133.png";